<template>
  <normal-dialog
    :title="type ? '编辑' : '新增'"
    :visible="visible"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
    width="720px"
    class="OtherEquipment-EditDialog"
  >
    <el-form
      :disabled="loading"
      label-width="100px"
      :inline="true"
    >
      <el-form-item label="所属区域">
        <span v-if="type">{{selected.campusName}}</span>
        <area-select
          v-else
          ref="areaSelect"
          v-model="selected.campusId"
          @change="areaChangeHandle"
          clearable
        />
      </el-form-item>
      <el-form-item label="服务类型">
        <span v-if="type">{{getServiceTypeName(selected.serviceType)}}</span>
        <ServiceTypeSelect
          v-else
          v-model="selected.serviceType"
          @change="serviceTypeChangeHandle"
          clearable
        />
      </el-form-item>
      <el-form-item label="运营商">{{selected.operatorName}}</el-form-item>
      <el-form-item label="设备型号">
        <span v-if="type">{{selected.deviceModelName}}</span>
        <DeviceModelSelect
          ref='DeviceModelSelect'
          v-else
          v-model="selected.deviceModelId"
          @change="deviceModelIdChangeHandle"
          clearable
        />
      </el-form-item>
      <el-form-item label="设备编号">
        <span v-if="type">{{selected.code}}</span>
        <el-input
          v-else
          v-model.trim="selected.code"
          :maxLength="8"
          clearable
        />
      </el-form-item>
      <el-form-item label="蓝牙模式">
        <el-select
          v-model="selected.bluetoothMode"
          clearable
        >
          <el-option
            v-for="(item, index) in bluetoothModeOptions"
            :key="index"
            :value="item.value"
            :label="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="反馈超过时间"
        class="straightline"
      >
        {{selected.feedbackOvertime?selected.feedbackOvertime+'s':''}}
      </el-form-item>

      <el-form-item
        label="设备位置"
        class="straightline"
      >
        <el-select
          v-model="selected.positionId"
          @change="positionChangeHandle"
          clearable
        >
          <el-option
            v-for="(item, index) in selected.positionList"
            :key="index"
            :value="item.id"
            :label="item.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="配置费率"
        class="straightline"
      >
        <el-select
          v-model="selected.rateId"
          @change="rateChangeHandle"
        >
          <el-option
            v-for="(item, index) in selected.rate"
            :key="index"
            :value="item.id"
            :label="item.name"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <div
      v-if="selected.rates.length"
      class="function-table"
    >
      <div class="function-table-row header">
        <div class="function-table-col">功能定义</div>
        <div class="function-table-col">功能定价/元</div>
        <div class="function-table-col">时长/min</div>
        <div
          v-if="selected.rates[0] && selected.rates[0].pulsesIsShow"
          class="function-table-col"
        >脉冲数量/个</div>
      </div>
      <div
        class="function-table-row"
        v-for="(item, index) in selected.rates"
        :key="index"
      >
        <div class="function-table-col">{{item.modelName}}</div>
        <div class="function-table-col">{{$priceFen2Yuan(item.price)}}</div>
        <div class="function-table-col">{{item.duration}}</div>
        <div
          v-if="item.pulsesIsShow"
          class="function-table-col"
        >{{item.pulsesNum}}</div>
      </div>
    </div>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="resetDialog">取 消</el-button>
      <el-button
        type="primary"
        @click="submitUpdateHandle"
        :loading="loading"
      >确 定</el-button>
    </div>
  </normal-dialog>
</template>

<script>
const dialogMixin = manageShell.default.mixinModule.Dialog;
import { mapGetters, mapActions } from 'vuex';
import ServiceTypeSelect, {
  serviceTypeMixin,
} from '../../components/ServiceTypeSelect/index';
import DeviceModelSelect from '../../components/DeviceModelSelect/index';

export default {
  props: {
    bluetoothModeOptions: { type: Array },
    getOperatorData: { type: Function },
    getRateListByAreaAndModel: { type: Function },
    getPositionList: { type: Function },
  },
  mixins: [dialogMixin, serviceTypeMixin],
  components: { ServiceTypeSelect, DeviceModelSelect },
  watch: {
    selected(val) {
      if (val.id) {
        let currentPostionItem = val.positionId
          ? {
              id: val.positionId,
              name: val.position,
            }
          : null;
        this.getPositionList({ campusId: val.campusId })
          .then(res => {
            let list = [];
            if (res.data && res.data.length) {
              list = res.data;
            }
            if (currentPostionItem) {
              list.push(currentPostionItem);
            }
            this.selected.positionList = list;
          })
          .catch(err => {
            console.log(err);
            this.selected.positionList = currentPostionItem
              ? [currentPostionItem]
              : [];
          });
        this.getRateListByAreaAndModel({
          campusId: val.campusId,
          deviceModelId: val.deviceModelId,
        })
          .then(res => {
            this.selected.rate = res.data;
            // this.selected.rates = [];
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
  },
  methods: {
    areaChangeHandle(val) {
      if (val) {
        this.getPositionList({ campusId: val })
          .then(res => {
            this.selected.positionList = res.data;
            this.selected.position = '';
            this.selected.positionId = undefined;
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.selected.positionList = [];
        this.selected.positionId = undefined;
        this.selected.position = '';
      }
      if (val) {
        this.selected.campusName = this.$refs.areaSelect.getAreaName(val);
      } else {
        this.selected.campusName = '';
      }
      if (val && this.selected.serviceType) {
        this.getOperatorData({
          areaId: val,
          serviceId: this.selected.serviceType,
        });
      } else {
        this.selected.serviceType = undefined;
        this.selected.operatorId = undefined;
        this.selected.operatorName = '';
      }
      if (val && this.selected.deviceModelId) {
        this.getRateListByAreaAndModel({
          campusId: val,
          deviceModelId: this.selected.deviceModelId,
        })
          .then(res => {
            this.selected.rate = res.data;
            this.selected.rates = [];
            this.selected.rateId = undefined;
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.selected.rateId = undefined;
        this.selected.rate = [];
        this.selected.rates = [];
      }
    },
    serviceTypeChangeHandle(val) {
      if (val && this.selected.campusId) {
        this.getOperatorData({
          areaId: this.selected.campusId,
          serviceId: val,
        });
      } else {
        this.selected.operatorId = undefined;
        this.selected.operatorName = '';
      }
    },
    deviceModelIdChangeHandle(val) {
      console.log('in val', val);
      if (val) {
        this.selected.feedbackOvertime = this.$refs.DeviceModelSelect.getFeedbackOvertime(
          val
        );
      } else {
        this.selected.feedbackOvertime = undefined;
      }
      if (val && this.selected.campusId) {
        this.getRateListByAreaAndModel({
          campusId: this.selected.campusId,
          deviceModelId: val,
        })
          .then(res => {
            this.selected.rate = res.data;
            this.selected.rates = [];
            this.selected.rateId = undefined;
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.selected.rateId = undefined;
        this.selected.rate = [];
        this.selected.rates = [];
      }
    },
    rateChangeHandle(val) {
      let rateDetail = this.selected.rate.find(item => item.id === val);
      if (rateDetail) {
        this.selected.rates = rateDetail.rates;
      }
    },
    positionChangeHandle(val) {
      let position = this.selected.positionList.find(item => item.id === val);
      if (position) {
        this.selected.position = position.name;
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../../assets/styles/variables.scss';
.OtherEquipment-EditDialog {
  .el-form-item {
    width: 302px;
  }
  .straightline {
    width: 100%;
  }
  .FormItem .FormItem-label {
    width: 100px;
    text-align-last: right;
  }
  .function-table {
    .function-table-row {
      display: flex;
      margin-bottom: 12px;
      justify-content: space-between;
      &.header {
        text-align: center;
      }
      .function-table-col {
        margin-right: 12px;
        width: 150px;
        text-align: center;
        &:last-child {
          margin-right: 0;
        }
        .el-input-number {
          width: 100%;
        }
      }
    }
  }
  .FormItem-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media screen and (min-width: $bigScreenWidth) {
    .FormItem .FormItem-label {
      width: 120px;
      text-align-last: right;
    }
  }
}
</style>
